import React from 'react';
import CustomTabs from 'components/Shared/CustomTabs';
import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useGetDocumentsBySourceQuery } from 'store/services/documentApi';
import { useGetTransactionsByMerchantQuery } from 'store/services/merchantApi';
import { useMerchantDetailContext } from 'contexts/MerchantDetailContext';
import { useSearchParams } from 'react-router-dom';
import CustomTabPanel from 'components/Shared/CustomTabPanel';
import NoteTab from '../../Note/Notetab';
import DocumentsTab from '../../Document/DocumentTab';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import TransactionTab from "./MerchantTransactionTab";

const MerchantDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'notes';
  const { merchantDetail } = useMerchantDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: 'Merchant',
      sourceRef: merchantDetail?._id,
    },
    { skip: !merchantDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'Merchant', sourceRef: merchantDetail?._id },
    { skip: !merchantDetail?._id }
  );

  const { data: transactions } = useGetTransactionsByMerchantQuery(
    { merchantId: merchantDetail?._id },
    { skip: !merchantDetail?._id }
  );

  const tabs = [
       {
      label: 'Notes',
      value: 'notes',
      badgeCount: notes?.length || 0,
    },
    {
      label: 'Document',
      value: 'document',
      badgeCount: documents?.totalItems || 0,
    },
     {
      label: 'Transactions',
      value: 'transactions',
      badgeCount: transactions?.totalItems || 0,
    },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {merchantDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value='transactions'>
            <TransactionTab />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value='notes'>
            <NoteTab source='Merchant' sourceRef={merchantDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value='document'>
            <DocumentsTab source='Merchant' sourceRef={merchantDetail._id} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default MerchantDetailTab;